module.exports = __webpack_public_path__ + "static/img/health-benefits.d8b349fa.png";